export default "__VITE_ASSET__75afe634__"